import { mapGetters } from "vuex";

export default {
    name: 'main-footer',
    data(){
        return {
            leftNav: ['mebel', 'shirmy-i-zerkala', 'dekor', 'iskusstvennye-rastenija'],
            rightNav: ['kovannye-izdelija', 'instrumenty', 'laboratorno-meditsinskoe-oborudovanie', 'posuda', 'steny-i-podiumy'],
        }
    },
    computed: {
        ...mapGetters({
            config: 'setting/config',
            menu: 'setting/menu',
        }),
        getPrivacyPolicy(){
            let link ='';
             this.config.find(e => {
                if(e.key === 'privacy_polic'){
                    link = e.value;
                }
            });
            return link;
        },
        getSocialItem(){
            return this.contacts.filter(e => {
                if(e.type === 'contact_social'){
                    e.img = require(`@/assets/img/svg/socials/${e.social_type}.svg`)
                    return e;
                }
            })
        },
        ...mapGetters({
            contacts: 'contacts/contacts'
        }),
    },
    methods: {
        getContactItem(key){
            return this.contacts.filter(e => {
                if(e.type === key){
                    return e;
                }
            });
        },
        getLinksNav(list){
            let arr = [];
            this.menu.forEach(e => {
                list.map(t => {
                    if(e.slug === t){
                        arr.push(e);
                    }
                });

            })
            return arr;
        }
    }
}
